import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledQualificationEmptyBox = styled(Flexbox)(
    ({theme: {palette, spacing}}) => css`
        background-color: ${palette.neutral[50]};
        padding: ${spacing * 4}px ${spacing * 6}px;
        border-radius: 8px;
    `
)

export const StyledUserQualificationEmptyBoxTitle = styled.h3(
    ({theme: {palette, typography}}) => css`
        ${typography.textMd};
        color: ${palette.neutral[500]};
    `
)

export const StyledUserQualificationEmptyBoxSubtitle = styled.h3(
    ({theme: {palette, typography}}) => css`
        ${typography.textSm};
        color: ${palette.neutral[500]};
    `
)

export const StyledQualificationTitle = styled.p(
    ({theme: {palette, typography}}) => css`
        ${typography.textSm};
        color: ${palette.neutral[950]};
        font-weight: 400;

        & > b {
            font-weight: 500;
        }
    `
)

export const StyledQualificationSubTitle = styled.p(
    ({theme: {palette, typography}}) => css`
        ${typography.textSm};
        color: ${palette.neutral[600]};
        font-weight: 400;
    `
)

export const StyledQualificationParagraph = styled.p(
    ({theme: {palette, typography}}) => css`
        ${typography.textXs};
        color: ${palette.neutral[600]};
        font-weight: 400;
    `
)

export const StyledQualificationRowSide = styled(Flexbox)(
    ({theme: {typography, palette}}) => css`
        ${typography.textSm};
        color: ${palette.neutral[600]};
        font-weight: 400;
        flex-shrink: 0;
    `
)
